module.exports = {
  "title": "Adding assets",
  "folder_upload_title": "Note: The files in this folder will start uploading once you click save.",
  "add_to_collection": "add assets to your collection",
  "empty_message": {
    "no_results_found": "No Results found",
    "no_asset_selected": "You did not add any document in your collection, please add files from connecting sources / stream & collection or upload from your computer",
    "no_matching_file": "no matching file found"
  },
  "paperflite": {
    "title": "Streams & collections",
    "sub_text": "Choose your assets from Paperflite",
    "description": "Some of your best content is on the hub. Go get it!",
    "search": {
      "placeholder": "Type here to search",
      "results": "Search results found",
      "search_for": "Search for"
    },
    "updated": "Updated",
    "my_streams": "My streams",
    "my_collection": "My collection"
  },
  "local_files": {
    "title": "Drag & Drop",
    "sub_text": "Files from anywhere or browse"
  },
  "url": {
    "title": "Add content URL",
    "sub_text": "Add a web URL link here",
    "error_message": "Please provide a valid url"
  },
  "actions": {
    "browse": "Browse"
  },
  "toast": {
    "uploading": "Uploading to",
    "assets_remaining": "assets remaining",
    "continue": "Continue",
    "similar_asset": {
      "title": "is exactly similar to",
      "description": "This asset {duplicateAssetName}, you are uploading is a duplicate of {originalAssetName} already available in your account. Would you like to {upload} a duplicate copy or {continue} using the existing version?"
    }
  }, 
  "asset_rate_limit": {
    "title" : "Warning",
    "content" : "You have exhausted the asset storage limit. Please contact your csm"
  }
}
